
export const CANCELFANDATA = { // grid config
  statusLabel: {
     ACTIVE: 'Active',
     PROCESSING: 'In Process',
     ADDED: 'Added'
  },
  fanList: { // fan list
    singlecol: {
      name: 'single-column',
      rowDisable: false,
      rowDisableCondition: { field: 'accountStatus', value: 'INACTIVE' },
      columnDefinitions: [
        {
          caption: 'Foundation account', field: 'fanId', type: 'TEXT', sortDirection: 'Asc',
          enableSorting: true, enableFilter: true, cssClass: '', priority: 1, customTemplate: ''
        }
      ]
    },
    multicol: {
      name: 'multi-column',
      rowDisable: true,
      rowDisableCondition: { field: 'accountStatus', value: 'INACTIVE' },
      columnDefinitions: [
        {
          caption: 'Foundation account', field: 'fanId', type: 'TEXT', sortDirection: 'Asc',
          enableSorting: true, enableFilter: true, cssClass: '', priority: 1, customTemplate: ''
        },
        {
          caption: 'Enrollment Program ID', field: 'accountStatus', type: 'CUSTOMTEMPLATE', sortDirection: 'Asc',
          enableSorting: false, enableFilter: false, cssClass: '', priority: 2, customTemplate: 'statusCellTemplate'
        }
      ]
    },
  },

  ReviewContents: {
    'allFans': `<h3>Review Fan's to be cancelled </h3> <p>You will be able to re-enroll your FAN's by going to the managemnt </p>`,
    'singleFan': ``,
    'signedupnotsetup': `<h3>Review FAN's to be cancelled</h3> 
                         <p>No devices are deployed. Only removing the signup. </p>
                         <p> Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem
                         Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum </p> <p>Thank you your administrator </p>`
  },

  confirmPageContents: {
    'allFans': `<h3>FAN's participation cancelled </h3> <p> you will be able to re-enroll your FAN's by going to the management 
                 section and selecting the set-up </p>
                 <p> Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem
                 Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum </p>`,
    'singleFan': `<h3>FAN's participation cancelled </h3> <p> you will be able to re-enroll your FAN's by going to the management 
                 section and selecting the set-up </p>
                 <p> Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem
                 Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum </p>`,
    'signedupnotsetup': `<h3>Review FAN's to be cancelled</h3> 
                         <p>Messaging saying that you have no devices deployed so you are only removing the sign up. 
                         You will need to start all over again </p>
                         <p> Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem
                         Ipsum, Lorem Ipsum, Lorem Ipsum, Lorem Ipsum </p>`
  }
};
